import { ImgFinder } from "components/common/ImgFinder/ImgFinder";
import e from "./style.module.css";
import { NavbarFooter } from "./Navbar/NavbarFooter";

export const Footer = () => {
  const callSegurnet = () => {
    window.location.href = "tel:+1-809-620-2524";
  };

  return (
    <>
      <footer className={e.footer__ctn}>
        <div>
          <NavbarFooter />
        </div>
        <div className={e.footer__data_ctn}>
          {/* Logo */}
          <div>
            <ImgFinder
              src="Segurnet-blanco.svg"
              alt="Segurnet logo - Seguros y reaseguros"
              className={e.footer__logo}
            />
          </div>

          <div className={e.footer__data_info}>
            {/* Redes */}
            <div>
              <a
                href="https://www.facebook.com/segurnetrd"
                rel="nofollow noopener noreferrer"
                target="_blank"
              >
                <ImgFinder
                  src="facebook.svg"
                  alt="Logo Facebook presione para ir a la aplicacion"
                  className={e["footer__icons-red"]}
                />
              </a>
              <a
                href="https://www.instagram.com/segurnetrd"
                rel="nofollow noopener noreferrer"
                target="_blank"
              >
                <ImgFinder
                  src="instagram.svg"
                  alt="Logo Instagram presione para ir a la aplicacion"
                  className={e["footer__icons-red"]}
                />
              </a>
              <span className={e["footer__icons-text"]}>SEGURNETRD</span>
            </div>

            <hr className={e.footer__line} />

            {/* Direccion */}
            <div className={e.direccion}>
              <div>
                <ImgFinder
                  src="Map.svg"
                  alt="Logo mapa"
                  className={e["footer__icons-cct"]}
                />
              </div>
              <div>
                <p>
                  Dirección: Calle Viriato Fiallo #24, Santo Domingo.Distrito
                  Nacional, República Dominicana
                </p>
              </div>
            </div>

            {/* Telefono */}
            <div className={e.telefono}>
              <div>
                <ImgFinder
                  src="tel.svg"
                  alt="Segurnet logo - Seguros y reaseguros"
                  className={e["footer__icons-cct"]}
                />
              </div>
              <div>
                <p onClick={callSegurnet}>Teléfono: (809) 620-2524</p>
              </div>
            </div>

            <hr className={e.footer__line} />

            {/* Copyrights */}
            <div className={e.copyright}>
              <p>© 2022 Segurnet - Seguros &#38; Reaseguros</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
